import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import { Select, FileInput } from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import { Col } from "react-bootstrap";

export default function Attachment({ fields, attachmentTypes, getField }) {
  const moreThanOne = fields.length >= 1;
  const options = toOptions(attachmentTypes);

  return (
    <div>
      {fields.map((attachment, index) => (
        <div key={`attachment-${attachment + index}`}>
          <h5 className="h4">
            Attachment #{index + 1}
            <button
              type="button"
              className="btn btn-xs btn-default btn-hollow pull-right"
              onClick={() => fields.remove(index)}
            >
              <i className="fa fa-fw fa-ban" />
              &nbsp;Remove
            </button>
          </h5>
          <div className="row">
            <Col md={8}>
              {getField && getField(`${attachment}.uploaded`) ? (
                <a
                  href={getField(`${attachment}.file_url`)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getField(`${attachment}.name`)}
                </a>
              ) : (
                <Field
                  name={`${attachment}.files`}
                  component={FileInput}
                  label="Upload Attachment"
                  multiple
                  required
                />
              )}
            </Col>
            <Col md={4}>
              <Field
                name={`${attachment}.attachment_type`}
                component={Select}
                label="Attachment Type"
                options={options}
                required
              />
            </Col>
          </div>
        </div>
      ))}
      <button
        type="button"
        onClick={() =>
          fields.push({ attachment_type: "photos_receiving_inspection" })}
        className="btn btn-primary btn-hollow"
        style={{ marginTop: 5, marginBottom: 15 }}
      >
        <i className="fa fa-fw fa-plus" />{" "}
        {moreThanOne ? "Add another attachment" : "Add attachment"}
      </button>
    </div>
  );
}

Attachment.defaultProps = {
  attachmentTypes: [],
  fields: []
};

Attachment.propTypes = {
  fields: T.shape({
    length: T.number,
    push: T.func
  }),
  attachmentTypes: T.instanceOf(Array),
  getField: T.func
};



// WEBPACK FOOTER //
// ./app/modules/Receiving/components/shared/FormSections/AttachmentListSection.jsx